module.exports = __webpack_public_path__ + "static/media/fu.5e76bd3a.png";